import backgroundImage from '../../../assets/images/auth-page-background.jpg';

const styles = theme => ({
  root: {
    textAlign: 'center',
    background: `linear-gradient(transparent, black), url(${backgroundImage})`,
    opacity: 0.9,
    backgroundSize: 'cover',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  grid: {
    padding: 0,
    margin: 0,
    width: '100%'
  },
  appbar: {
    background: 'transparent',
    boxShadow: 'none'
  },
  paperWrapper: {
    paddingTop: theme.spacing.unit * 2,
    margin: 'auto',
    minWidth: 280,
    maxWidth: 400
  },
  paper: {
    borderRadius: theme.spacing.unit,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3
  },
  logo: {
    margin: 0,
    padding: 0,
    height: 40
  },
  content: {
    margin: 0,
    padding: 0
  }
});

export default styles;
